/** Tur qidiruvi, K3 (Brief 12). */
export const uzB12Search = {
  "tq12.tab.cruise": "Kruiz",
  "tq12.clientChip": "Mijoz uchun:",
  "tq12.clientChipDeal": "Bitim №{number}",
  "tq12.selectionCount": "Tanlov · {count}",
  "tq12.inSelection": "Tanlovda",
  "tq12.sel.empty": "Hali hech narsa tanlanmagan. Natijalarda «+ Tanlovga» ni bosing.",
  "tq12.sel.brutto": "Mijozga faqat brutto narx ko'rinadi.",
  "tq12.sel.bruttoDeal": "Mijozga faqat brutto narx ko'rinadi. Tanlov Bitim №{number} tarixiga yoziladi.",
  "tq12.sel.needVariant": "Avval variant tanlang",
  "tq12.sel.cardSent": "{count} ta variant suhbatga karta bo'lib ketdi · faqat brutto",
  "tq12.field.from": "Qayerdan",
  "tq12.field.to": "Qayerga",
  "tq12.field.window": "Uchish oralig'i",
  "tq12.field.nights": "Kechalar",
  "tq12.field.who": "Kim boradi",
  "tq12.field.windowFrom": "Boshlanishi",
  "tq12.field.windowTo": "Oxiri",
  "tq12.field.nightsFrom": "Kamida",
  "tq12.field.nightsTo": "Ko'pi bilan",
  "tq12.field.adults": "Kattalar",
  "tq12.field.childAges": "Bolalar yoshi, vergul bilan",
  "tq12.field.pick": "Tanlang",
  "tq12.field.charterAndRegular": "charter va muntazam",
  "tq12.field.charterOnly": "faqat charter",
  "tq12.who.adults": "{count} katta",
  "tq12.who.children": "{count} bola ({ages})",
  "tq12.aiPlaceholder": "Masalan: Misr, noyabr boshida, 2 katta + bola 7 yosh, 1 500 $ gacha, dengiz bo'yida",
  "tq12.aiFill": "Maydonlarga",
  "tq12.quick": "Tez tanlash",
  "tq12.quickFrom": "dan {price}",
  "tq12.calendar": "Narx kalendari · uchish kuni bo'yicha eng arzon",
  "tq12.filter.resort": "Kurort",
  "tq12.filter.anyResort": "Istalgan kurort",
  "tq12.filter.level": "Mehmonxona darajasi",
  "tq12.filter.board": "Ovqatlanish",
  "tq12.filter.operators": "Turoperatorlar",
  "tq12.filter.important": "Muhim",
  "tq12.filter.halal": "Halol menyu",
  "tq12.filter.from": "dan {price}",
  "tq12.filter.open": "Filtrlar",
  "tq12.seat.legend": "Joy holati:",
  "tq12.seat.ok": "bor",
  "tq12.seat.few": "kam (qolgan joy)",
  "tq12.seat.none": "yo'q · stop sale",
  "tq12.seat.hideStop": "Stop sale'larni yashirish",
  "tq12.summary": "{hotels} mehmonxona · {operators} operatordan",
  "tq12.compared": "Narxlar solishtirildi",
  "tq12.partial.title": "{names} javob bermadi.",
  "tq12.partial.body": "Natijalar to'liq emas, qolgan provayderlar narxlari ko'rsatilgan.",
  "tq12.allFailed.title": "Provayderlar javob bermadi",
  "tq12.allFailed.body": "Bu tarmoq yoki provayder tomonidagi muammo. Agentlik paketlari qidiruvda qoladi.",
  "tq12.allFailed.retry": "Qayta qidirish",
  "tq12.noResults.title": "Bu parametrlarga joy topilmadi",
  "tq12.noResults.body": "Sanani ±3 kunga surib ko'ring yoki yulduz filtrini olib tashlang.",
  "tq12.noResults.widen": "±3 kun",
  "tq12.noFilter.body": "Filtrlarga mos mehmonxona yo'q. Ovqatlanish yoki darajani kengaytiring.",
  "tq12.noFilter.reset": "Filtrlarni tozalash",
  "tq12.provider.results": "{count} ta",
  "tq12.provider.empty": "0 natija",
  "tq12.provider.error": "xato",
  "tq12.provider.waiting": "kutilmoqda",
  "tq12.start.title": "Qidiruvni boshlang",
  "tq12.start.body": "Davlat va sanani tanlab, «Topish» ni bosing. Hamma operatorlar birdaniga so'raladi.",
  "tq12.noOperator.title": "Turoperator ulanmagan",
  "tq12.noOperator.body": "Qidiruv uchun kamida bitta turoperator login yoki API kaliti kerak.",
  "tq12.noOperator.bodyStaff": "Qidiruv uchun kamida bitta turoperator kerak. Agentlik egasidan ulashni so'rang.",
  "tq12.noOperator.action": "Turoperator ulash",
  "tq12.error.title": "Qidiruv ishlamadi",
  "tq12.error.body": "Server javob bermadi. Kiritgan ma'lumotlaringiz saqlangan, sahifani qayta yuklash xavfsiz.",
  "tq12.card.more": "Yana {count} ta operator narxi",
  "tq12.card.fewer": "Yashirish",
  "tq12.card.detail": "Batafsil",
  "tq12.card.soldTimes": "Oxirgi oyda siz bu mehmonxonani {count} marta sotgansiz",
  "tq12.card.ratingSource": "{source} reytingi",
  "tq12.card.noPhoto": "Rasm yo'q",
  "tq12.card.nettoLine": "netto {netto} · foyda {profit}",
  "tq12.card.bookReminder": "Operator saytida bron qilgach, bron raqamini bitimga kiriting.",
  "tq12.detail.ratings": "Reytinglar",
  "tq12.detail.offers": "Barcha narxlar",
  "tq12.detail.photos": "Rasmlar",
  "tq12.hotel.city": "Shahar yoki mehmonxona",
  "tq12.hotel.checkIn": "Kirish",
  "tq12.hotel.checkOut": "Chiqish",
  "tq12.hotel.guests": "Mehmonlar va xonalar",
  "tq12.hotel.guestsValue": "{adults} katta · 1 xona",
  "tq12.hotel.pricePerNight": "Bir kecha narxi",
  "tq12.hotel.priceMin": "Narx dan",
  "tq12.hotel.priceMax": "Narx gacha",
  "tq12.hotel.area": "Hudud",
  "tq12.hotel.anyArea": "Istalgan hudud",
  "tq12.hotel.conditions": "Shartlar",
  "tq12.hotel.summary": "{count} mehmonxona · {dates}, {nights} kecha · {adults} katta",
  "tq12.hotel.night": "1 kecha · jami {total}",
  "tq12.hotel.nettoNight": "netto {netto} / jami",
  "tq12.hotel.freeCancel": "Bepul bekor qilish · {date} gacha",
  "tq12.hotel.nonRefundable": "Qaytarilmaydigan tarif",
  "tq12.hotel.moreSources": "Yana {count} ta manba",
  "tq12.hotel.hideSources": "Yashirish",
  "tq12.hotel.mapLarger": "Kattaroq xarita",
  "tq12.hotel.mapSmaller": "Kichikroq xarita",
  "tq12.hotel.start": "Shahar va sanalarni tanlab, «Topish» ni bosing.",
  "tq12.hot.within": "Uchishgacha {count} kun",
  "tq12.hot.budget": "2 kishiga, gacha",
  "tq12.hot.all": "Hammasi · {count}",
  "tq12.hot.seats": "{count} joy qoldi",
  "tq12.hot.matched": "{count} ta mos mijoz",
  "tq12.hot.send": "Mijozga yuborish",
  "tq12.hot.fromAll": "Barcha shaharlar",
  "tq12.avia.note": "Narx hamkor manbasidan. Sotib olish hamkor saytida.",
  "tq12.avia.dates": "Sanalar",
  "tq12.avia.datesPick": "Sanani tanlang",
  "tq12.avia.depart": "Borish",
  "tq12.avia.return": "Qaytish",
  "tq12.avia.passengers": "Yo'lovchilar va klass",
  "tq12.avia.passengersValue": "{count} katta · Ekonom",
  "tq12.avia.adults": "Yo'lovchilar",
  "tq12.avia.direct": "To'g'ridan-to'g'ri",
  "tq12.avia.stopCount": "{count} peresadka",
  "tq12.avia.hand": "Qo'l yuki {kg} kg",
  "tq12.avia.bag": "Bagaj {kg} kg",
  "tq12.avia.noBag": "Bagajsiz",
  "tq12.avia.withBag": "Bagaj bilan",
  "tq12.avia.buy": "Sotib olish",
  "tq12.avia.start": "Marshrut va sanani tanlab, «Topish» ni bosing.",
  "tq12.avia.bestFor": "{airline} · {duration}",
  "tq12.pkg.yaqin": "Yaqin chiqishlar",
  "tq12.pkg.seats": "{count} joy",
  "tq12.pkg.perPerson": "1 kishiga",
  "tq12.pkg.nettoLine": "netto {netto} · foyda {profit}",
  "tq12.pkg.soldLine": "{sold} / {quota} joy sotildi · {pct}%",
  "tq12.pkg.new": "Yangi paket",
  "tq12.cruise.region": "Region",
  "tq12.cruise.port": "Jo'nash porti",
  "tq12.cruise.window": "Sana oralig'i",
  "tq12.cruise.nights": "Kechalar",
  "tq12.cruise.passengers": "Yo'lovchilar",
  "tq12.cruise.any": "Istalgan",
  "tq12.cruise.summaryCount": "{count} ta kruiz",
  "tq12.cruise.priceFrom": "dan, {count} kishiga",
  "tq12.cruise.priceAbout": "taxminan, {count} kishiga",
  "tq12.cruise.estimate": "Taxminiy narx · aniq narx so'rov orqali",
  "tq12.cruise.request": "So'rov yuborish",
  "tq12.cruise.requested": "So'rov yuborildi · vazifa ochildi, javob 24 soat ichida",
  "tq12.cruise.back": "Natijalar",
  "tq12.cruise.detailLine": "{line} · {dates} · {nights} kecha · {port}dan",
  "tq12.cruise.route": "Kunma-kun marshrut",
  "tq12.cruise.day": "{day}-kun",
  "tq12.cruise.dayDate": "{day}-kun · {date}",
  "tq12.cruise.atSea": "Dengizda",
  "tq12.cruise.cabins": "Kayuta kategoriyalari",
  "tq12.cruise.cabin": "Kayuta",
  "tq12.cruise.size": "O'lcham",
  "tq12.cruise.capacity": "Sig'im",
  "tq12.cruise.board": "Ovqatlanish",
  "tq12.cruise.priceFor": "{count} kishiga",
  "tq12.cruise.none.title": "Bu sanalarga kruiz topilmadi",
  "tq12.cruise.none.body": "Sana oralig'ini kengaytiring yoki boshqa portni tanlang.",
  "tq12.cruise.noProvider.title": "Kruiz provayderi ulanmagan",
  "tq12.cruise.noProvider.body": "Hozircha narxlarni tizim o'zi ololmaydi. So'rov yuboring: operatorga vazifa ochiladi va u kruizni qo'lda topadi.",
  "tq12.cruise.start.title": "Kruiz qidiruvi",
  "tq12.cruise.start.body": "Region va sanani tanlab, «Topish» ni bosing.",
  "tq12.cruise.error": "Kruizlarni olib bo'lmadi. Qayta urinib ko'ring.",
  "tq12.sel.kind.cruise": "Kruiz",
  "tq12.weekday.0": "Ya",
  "tq12.weekday.1": "Du",
  "tq12.weekday.2": "Se",
  "tq12.weekday.3": "Ch",
  "tq12.weekday.4": "Pa",
  "tq12.weekday.5": "Ju",
  "tq12.weekday.6": "Sh",
} as const;
